import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';

/**
 * Telegram BackButton lifecycle hook.
 * Mounts: shows BackButton + registers handler.
 * Unmounts: hides + unregisters handler.
 * onClick must be stable (useCallback at call site).
 */
export function useBackButton(onClick: () => void): void {
  useEffect(() => {
    WebApp.BackButton.onClick(onClick);
    WebApp.BackButton.show();
    return () => {
      WebApp.BackButton.offClick(onClick);
      WebApp.BackButton.hide();
    };
  }, [onClick]);
}
